import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import InvoicePaymentConditionGeneralForm from '@/components/Fiscal/Invoice/InvoiceForms/InvoicePaymentConditionGeneralForm';
import { DefaultRouteTabs, SaveButton } from '@/components/_common';
import { PageProps } from '@/types/PageProps';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { Divider } from 'antd';
import invoiceValidateRoutes from '../../Invoice.validateRoutes';
import { useLocation } from 'react-router-dom';
import InvoiceButtonsRepeated from '../InvoiceButtonsRepeated';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import InvoiceDeleteButton from '@/components/_common/InvoiceDeleteButton';

export default function InvoicePaymentConditionGeneralPage({
  route,
}: PageProps) {
  const {
    handleSubmit,
    disabled,
    disabledFields,
    isLoading,
    invoiceId,
    invoice: { data: invoice, isLoading: invoiceIsLoading },
  } = useInvoiceFormContext();

  const { pathname } = useLocation();
  const URL = '/' + pathname.split('/').slice(1, -1).join('/');

  return (
    <DefaultRouteTabs
      route={invoiceValidateRoutes(route, invoice?.situation)}
      baseKey={invoiceId}
      permissions={route.permissions}
      basePath={URL}
      resourceNotFound={!invoice && !invoiceIsLoading}
      extra={
        <SpaceForButton>
          <InvoiceDeleteButton />

          <SaveButton
            block
            onClick={handleSubmit}
            disabled={disabled || disabledFields}
            loading={isLoading}
          >
            Salvar
          </SaveButton>
        </SpaceForButton>
      }
    >
      <Helmet title={useIntl().formatMessage({ id: route.name })} />

      <InvoicePaymentConditionGeneralForm />

      <Divider />

      <InvoiceButtonsRepeated />
    </DefaultRouteTabs>
  );
}
